/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
var E,I;!function(E){E[E.VISIBLE_ONLY=0]="VISIBLE_ONLY",E[E.ALL=1]="ALL",E[E.QUERYABLE=2]="QUERYABLE"}(E||(E={})),function(E){E[E.EXIT=0]="EXIT",E[E.CONTINUE=1]="CONTINUE",E[E.SKIP=2]="SKIP"}(I||(I={}));export{E as ForAllFeaturesMode,I as ForAllFeaturesReturnType};
